<template>
  <div id="mapEchart" :style="{ width: '100%', height: '900px' }"></div>
</template>

<script>
import * as echarts from "echarts";
import {onMounted, onUnmounted } from 'vue'
import chinaData from '../static/中华人民共和国.json'
export default {
  name: "echartsBox",
  data(){
    return {
      chinaData
    }
  },
  setup() {
      let chinaData2 = [
      {name: '江苏', value: 19638},
      {name: '广东', value: 19490},
      {name: '浙江', value: 7990},
      {name: '北京市', value: 9044},
      {name: '上海市', value: 7831},
      {name: '安徽', value: 6561},
      {name: '黑龙江', value: 6099},
      {name: '四川', value: 5613},
      {name: '山东', value: 3551},
      {name: '湖北', value: 3973},
      {name: '中国台湾', value: 3136},
      {name: '陕西', value: 3235},
      {name: '福建', value: 2793},
      {name: '天津市', value: 2130},
      {name: '湖南', value: 1780},
      {name: '辽宁', value: 1527},
      {name: '江西', value: 1620},
      {name: '河南', value: 1466},
      {name: '河北', value: 1470},
      {name: '重庆市', value: 1077},
      {name: '广西壮族自治区', value: 732},
      {name: '吉林', value: 709},
      {name: '贵州', value: 589},
      {name: '云南', value: 549},
      {name: '内蒙古', value: 444},
      {name: '山西', value: 440},
      {name: '甘肃', value: 256},
      {name: '新疆', value: 208},
      {name: '宁夏回族自治区', value: 246},
      {name: '香港', value: 177},
      {name: '海南', value: 118},
      {name: '青海', value: 104},
      {name: '澳门', value: 9},
      {name: '西藏', value: 4},
    ]
    /// 声明定义一下echart
    let echart = echarts;
    onMounted(() => {
      mapEchart(chinaData,chinaData2);
    });

    onUnmounted(() => {
      echart.dispose();
    });
	
    // 基础配置一下Echarts
    function mapEchart(data,data2) {
      let chart = echart.init(document.getElementById("mapEchart"));
      echarts.registerMap('china', data);
      // 把配置和数据放这里
      chart.setOption({
        // backgroundColor: '#0e2152',
      tooltip: {
       trigger: 'item',
       show: true,
       padding: 0,
       backgroundColor: 'rgba(0,0,0,0.5)',
       textStyle: {
        color: '#fff',
        fontSize: 16
       },
        formatter: function(params){
          if(params.data) {
          let str = `<div class="tip">
          <p>${params.data.name}:<span>${params.data.value}</span></p>
          </div>`
          return str;
          }
      
        }
        },
        series: [
              {
                type: 'map',
                roam: true,
                geoIndex: 0,
                data: data2,
                label:{
                  show: true,
                }
              }
        ],
        geo:{
          roam: false,// 关闭拖拽
          zoom: 1.23,
          map: 'china',
          isLand : false,
          regions: [
            {
              name: '南海诸岛',
              value: 0,
              label: {
                show: false,
              },
              itemStyle: {
                normal: {
                  opacity: 0,
                }
              }
            }
          ],
          label: {
            normal: {
              show: false,//省份名展示
              textStyle: {
                color: '#2dd3f8',
                fontSize: 16,
              }
            },
            emphasis:{
              textStyle: {
                color: '#f6e410',
                fontSize: '20px',
                fontWeight: 500
              }
            },
          },
          itemStyle: {
            normal: {
              borderColor: '#2dd3f8',
              borderWidth: 1,
              areaColor: "#0f3873",
            },
            emphasis:{
              areaColor: '#2dd3f8',
              borderWidth: 0
            },
          },
        }
      });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    return { mapEchart};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.total{
  display: flex;
  align-items: center;
  justify-content: center;
}
.num{
  display: flex;
  color: #fff;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.num p{
  font-size: 24px;
}
.total{
  border-style: solid;
  border-width: 1px;
  border-color: #088DF2;
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px 1px #088df2;
  padding: 12px;
}
.stats {
  display: flex;
  flex-direction: column;
}
.stats div{
    border-style: solid;
    border-width: 1px;
    border-color: #088DF2;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0px 0px 10px 1px #088df2;
    padding: 15px 24px;
    color: #fff;
}
/deep/div.tip{
  padding: 10px 15px;
}
/deep/div.tip p{
  line-height: 30px;
  text-align: right;
  color: #fff;
  font-weight: 600;
}
/deep/div.tip p span{
  padding-left: 20px;
}
/deep/.tip p:nth-child(1){
 color: #ef9015;
}
#mapEchart{
  padding-top: 25px;
}
</style>
